import { Component } from "react";
import { connect } from "react-redux";
import TableWithoutPaginationOrange from "../../Table/TableWithoutPaginationOrange";
import FormField from "../FormField";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import { clone, distinct } from "../../../utils";

class FormTableField extends Component {
    constructor(props) {
        super(props);

        let columnHeaders = props.metaQuestion.column_heading_ids;
        let rows = props.question.response_tables.map((rt) => rt.name).filter(distinct);

        this.state = {
            rows,
            columns: columnHeaders.map((ch) => {
                if (ch.id)
                    return {
                        Header: ch.title,
                        id: ch.id,
                        filterable: false,
                        minWidth: 150,
                        width: 150,
                        maxWidth: 250,
                        Cell: (row) => {
                            let rowName = row.row.original;

                            let responseTableCell = clone(
                                this.props.question.response_tables.find(
                                    (rt) => rt.name === rowName && rt.column_id === ch.id
                                )
                            );

                            if (!responseTableCell)
                                responseTableCell = {
                                    column_id: ch.id,
                                    table: rowName,
                                    response_table_id: this.props.question.id,
                                    value: "",
                                }; //On génère une réponse par défaut

                            return (
                                <FormField
                                    responseValueChange={this.childrenValueChange(rowName, ch.id)}
                                    disabled={this.props.inputProperties.disabled}
                                    id={rowName + "-" + ch.id}
                                    metaQuestion={{ question: "", type: "single_textbox" }}
                                    question={responseTableCell}
                                    subField
                                    visible={this.props.inputProperties.visible}
                                    save={this.props.save}
                                />
                            );
                        },
                    };
                else
                    return {
                        Header: ch.title,
                        accessor: "answer",
                        minWidth: 150,
                        width: 150,
                        maxWidth: 250,
                        className: "large-text-cell",
                    };
            }),
        };
    }

    static getDerivedStateFromProps(props, state) {
        let rows = props.question.response_tables.map((rt) => rt.name).filter(distinct);
        state.rows = [...rows];
        return state;
    }

    childrenValueChange = (rowName, columnId) => (childrenResponseValue) => {
        let responseAnswers = clone(this.props.question.response_tables);
        let responseAnswerIndex = responseAnswers.findIndex((r) => r.name === rowName && r.column_id === columnId);

        responseAnswers.splice(responseAnswerIndex, 1, childrenResponseValue);

        let response = clone(this.props.question);
        response.response_tables = responseAnswers;
        this.props.responseValueChange(response);
    };

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <div className="control-margin-top">
                <TableWithoutPaginationOrange
                    minRows={2}
                    {...this.props.inputProperties}
                    data={this.state.rows}
                    columns={this.state.columns}
                    sortable={false}
                />
            </div>
        );
    }
}

const mapStateToProps = () => {
    return {};
};

const mapDispatchToProps = () => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(FormTableField);
